import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-3" }

import { Checkbox } from '@/components/ui/checkbox';
    import { Label } from '@/components/ui/label';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeOptionalForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const checkboxKeys = Object.keys(props.form.data());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checkboxKeys), (key) => {
      return (_openBlock(), _createBlock(_unref(Label), {
        key: key,
        class: "flex flex-row items-center gap-2 font-normal"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Checkbox), {
            "model-value": props.form[key] === 1,
            "onUpdate:modelValue": (val) => (props.form[key] = val ? 1 : 0)
          }, null, 8, ["model-value", "onUpdate:modelValue"]),
          _createElementVNode("span", null, _toDisplayString(_unref(t)(`employees-optionals.table.${key}`)), 1)
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}
}

})